// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/custom-font/index.css
// module id = /hvx
// module chunks = 24